<template> 
  <div> 
    <div class="ms-4">
        <div class="page-title flex-row me-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('paid_list') }}
            </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li>   
                <li class="breadcrumb-item text-primary">{{ $t('financial_reports') }}</li>  
                <li class="breadcrumb-item text-gray-600">{{ $t('paid_list') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content">
        <div class="card">
            <div class="card-header border-0 pt-6 px-7">
               <div class="card-title">
                    <div class="fv-row mb-4 row ">
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('currency') }}</span>
                            </label>
                            <Select2 v-model="form.currency" :options="currencyList" :settings="{width: '100%'}" />
                        </div>
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('date_type') }}</span>
                            </label>
                            <Select2 v-model="form.date_type" :options="dateTypeList" :settings="{width: '100%'}" />
                        </div>
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span v-if="form.date_type == 1">{{ $t('start_due_date') }}</span>
                                <span v-if="form.date_type == 2">{{ $t('start_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.first_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div> 
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span v-if="form.date_type == 1">{{ $t('end_due_date') }}</span>
                                <span v-if="form.date_type == 2">{{ $t('end_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.last_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div> 
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('remain_status') }}</span>
                            </label>
                            <Select2 v-model="form.remain_status" :options="isRemainStatusList" :settings="{width: '100%'}" />
                        </div>
                    </div>
                </div>
                <div class="card-toolbar" v-if="this.$isCredentialActive(71,'R')">
                    <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                        <Popper hover placement="top">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper> 
                        <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                            </svg>
                            </span>
                            <span v-if="!this.isListProgressing"> {{ $t('list') }} </span> 
                            <span class="indicator-progress" v-if="this.isListProgressing">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button> 
                    </div> 
                </div>
            </div>
            <div class="card-body pt-3">
                <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="row min-h-300px"> 
                        <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                        <DxDataGrid id="gridContainer"
                            :key="$i18n.locale"
                            :show-borders="true"
                            key-expr="id"
                            :data-source="lists"
                            :allow-column-reordering="true" 
                            :allow-column-resizing="true"
                            :column-auto-width="true"
                            :row-alternatin-enabled="true"
                            :hover-state-enabled="true" 
                            :show-row-lines="true" 
                            :ref="'dataGrid'"
                            :customize-columns="onCustomizeColumn"
                            @exporting="this.$onExporting($event , 'Paid-List')">   
                            <DxFilterRow :visible="true"/>
                            <DxHeaderFilter :visible="true"/>
                            <DxGroupPanel :visible="true"/>      
                            <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                            <DxPaging :page-size="pageSize"/>
                            <DxPager :visible="false" :allowed-page-sizes="pageSizesLists" :show-page-size-selector="showPageSizeSelectorLists" :show-info="true" :show-navigation-buttons="true"/>    
                            <DxSearchPanel :visible="true"/>
                            <DxScrolling
                                mode="virtual"
                                row-rendering-mode="virtual"
                            />
                            <DxColumn data-field="transaction_date" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('transaction_date')" header-cell-template="transaction_date-header"/>
                            <DxColumn data-field="transaction_due_date" :caption="$t('transaction_due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="transaction-duedate-header"/> 
                            <DxColumn data-field="account_name" :caption="$t('account')" />
                            <DxColumn data-field="transaction_type_name" :caption="$t('transaction_type')" header-cell-template="transaction-type-header"/> 
                            <DxColumn data-field="transaction_subtype_name" :caption="$t('sub_type')" header-cell-template="transaction-subtype-header"/> 
                            <DxColumn data-field="transaction_no" :caption="$t('transaction_no')" header-cell-template="transaction-no-header"/>
                            <DxColumn data-field="currency" :caption="$t('currency')"/> 
                            <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right"/> 
                            <DxColumn data-field="rate" :sorting-method="this.$numericSort" :caption="$t('rate')" alignment="right"/> 
                            <DxColumn data-field="used_amount" :sorting-method="this.$numericSort" :caption="$t('paid_amount')" alignment="right" header-cell-template="closed-amount-header"/> 
                            <DxColumn cssClass="bg-light-danger" data-field="remain_amount" :sorting-method="this.$numericSort" :caption="$t('remain_amount')" alignment="right" header-cell-template="remain-amount-header" cell-template="remain_amount-cell-template"/> 
                            <DxColumn data-field="local_amount" :sorting-method="this.$numericSort" :caption="$t('amount_local')" alignment="right" header-cell-template="amount-local-header"/> 
                            <DxColumn data-field="used_local_amount" :sorting-method="this.$numericSort" :caption="$t('paid_amount_local')" alignment="right" header-cell-template="closed-local-amount-header"/> 
                            <DxColumn data-field="remain_local_amount" :sorting-method="this.$numericSort" :caption="$t('remain_amount_local')" alignment="right" header-cell-template="remain-amount-local-header"/> 
                            <DxColumn data-field="record_date" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('record_date')" header-cell-template="record-date-header"/>
                            <DxColumn data-field="id" :caption="$t('payment')" alignment="center" cell-template="payment-modal-cell-template" />

                            <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                            <template #headerLocalTemplate="{ data: data }">
                                <div v-html="setColumnTemplateForLocal(data)"></div> 
                            </template>

                            <template #record-date-header>
                                <div>{{ $t('record_date') }}</div>
                            </template>
                            <template #transaction_date-header>
                                <div>{{ $t('transaction_date') }}</div>
                            </template>
                            <template #transaction-type-header>
                                <div>{{ $t('transaction_type') }}</div>
                            </template>
                            <template #transaction-subtype-header>
                                <div>{{ $t('sub_type') }}</div>
                            </template>
                            <template #collection-transaction-type-header>
                                <div>{{ $t('payment_transaction_type') }}</div>
                            </template>
                            <template #collection-transaction-no-header>
                                <div>{{ $t('payment_transaction_no') }}</div>
                            </template>
                            <template #transaction-no-header>
                                <div>{{ $t('transaction_no') }}</div>
                            </template>
                            <template #transaction-duedate-header>
                                <div>{{ $t('transaction_due_date') }}</div>
                            </template>
                            <template #closed-amount-header>
                                <div>{{ $t('paid_amount') }}</div>
                            </template>
                            <template #amount-local-header>
                                <div>{{ $t('amount_local') }}</div>
                            </template>
                            <template #closed-local-amount-header>
                                <div>{{ $t('paid_local_amount') }}</div>
                            </template>
                            <template #remain-amount-header>
                                <div>{{ $t('remain_amount') }}</div>
                            </template>
                            <template #remain-amount-local-header>
                                <div>{{ $t('remain_local_amount') }}</div>
                            </template>
                            <template #first-rate-header>
                                <div>{{ $t('first_rate') }}</div>
                            </template>
                            <template #last-local-amount-header>
                                <div>{{ $t('last_local_amount') }}</div>
                            </template>
                            <template #collection-amount-header>
                                <div>{{ $t('payment_amount') }}</div>
                            </template>
                            <template #collection-amount-local-header>
                                <div>{{ $t('payment_amount_local') }}</div>
                            </template>
                            <template #collection-remain-amount-header>
                                <div>{{ $t('payment_remain') }}</div>
                            </template>
                            <template #collection-remain-amount-local-header>
                                <div>{{ $t('payment_remain_local') }}</div>
                            </template>
                            <template #payment-modal-cell-template="{ data }"> 
                                <span class="align-middle">  
                                    <button class="btn btn-sm btn-icon btn-secondary btn-icon-dark btn-text-dark w-20px h-20px" @click="viewDetail(data.data.id)"
                                            data-bs-toggle="modal" data-bs-target="#kt_modal_view_collection_and_payment" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                        <span class="svg-icon svg-icon-muted icon-size-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21.7 18.9L18.6 15.8C17.9 16.9 16.9 17.9 15.8 18.6L18.9 21.7C19.3 22.1 19.9 22.1 20.3 21.7L21.7 20.3C22.1 19.9 22.1 19.3 21.7 18.9Z" fill="currentColor"/>
                                        <path opacity="0.3" d="M11 20C6 20 2 16 2 11C2 6 6 2 11 2C16 2 20 6 20 11C20 16 16 20 11 20ZM11 4C7.1 4 4 7.1 4 11C4 14.9 7.1 18 11 18C14.9 18 18 14.9 18 11C18 7.1 14.9 4 11 4ZM8 11C8 9.3 9.3 8 11 8C11.6 8 12 7.6 12 7C12 6.4 11.6 6 11 6C8.2 6 6 8.2 6 11C6 11.6 6.4 12 7 12C7.6 12 8 11.6 8 11Z" fill="currentColor"/>
                                        </svg>
                                        </span>
                                    </button> 
                                </span>
                            </template>
                            
                            <template #remain_amount-cell-template="{ data }">
                                <span class="p-3 align-middle" :class="{'text-danger fw-bold': parseFloat(data.data.remain_amount) > 0, 'text-gray-700': parseFloat(data.data.remain_amount) == 0}">
                                    <button class="btn btn-sm btn-icon btn-secondary btn-icon-danger btn-text-danger w-20px h-20px me-1" v-if="parseFloat(data.data.remain_amount) > 0" @click="onRedirectBalanceClosing(data.data)">
                                        <span class="svg-icon svg-icon-danger svg-icon-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M4.7 17.3V7.7C4.7 6.59543 5.59543 5.7 6.7 5.7H9.8C10.2694 5.7 10.65 5.31944 10.65 4.85C10.65 4.38056 10.2694 4 9.8 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H18C19.1046 21 20 20.1046 20 19V14.2C20 13.7306 19.6194 13.35 19.15 13.35C18.6806 13.35 18.3 13.7306 18.3 14.2V17.3C18.3 18.4046 17.4046 19.3 16.3 19.3H6.7C5.59543 19.3 4.7 18.4046 4.7 17.3Z" fill="currentColor"/>
                                                <rect x="21.9497" y="3.46448" width="13" height="2" rx="1" transform="rotate(135 21.9497 3.46448)" fill="currentColor"/>
                                                <path d="M19.8284 4.97161L19.8284 9.93937C19.8284 10.5252 20.3033 11 20.8891 11C21.4749 11 21.9497 10.5252 21.9497 9.93937L21.9497 3.05029C21.9497 2.498 21.502 2.05028 20.9497 2.05028L14.0607 2.05027C13.4749 2.05027 13 2.52514 13 3.11094C13 3.69673 13.4749 4.17161 14.0607 4.17161L19.0284 4.17161C19.4702 4.17161 19.8284 4.52978 19.8284 4.97161Z" fill="currentColor"/>
                                            </svg>
                                        </span>
                                    </button> 
                                    {{data.data.remain_amount}}
                                </span>
                            </template>

                            <DxStateStoring
                                :enabled="true"
                                type="custom"
                                :storage-key="this.storageKey"
                                :ref="dataGrid" 
                                :saving-timeout="1000"
                                :custom-load="LoadDXState"
                            />

                            <DxSummary :calculate-custom-summary="setSummaries">
                                <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="transaction_due_date"/>
                                <DxGroupItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    :show-in-group-footer="true"
                                    name="amount"
                                    summary-type="custom"
                                    show-in-column="amount"
                                    display-format="{0}"
                                /> 
                                <DxTotalItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    name="amount"
                                    summary-type="custom"
                                    show-in-column="amount"
                                />
                                <DxGroupItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    :show-in-group-footer="true"
                                    name="remain_amount" summary-type="custom" show-in-column="remain_amount" display-format="{0}"
                                /> 
                                <DxTotalItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    name="remain_amount" summary-type="custom" show-in-column="remain_amount"
                                />
                                <DxGroupItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    :show-in-group-footer="true"
                                    name="used_amount" summary-type="custom" show-in-column="used_amount" display-format="{0}"
                                /> 
                                <DxTotalItem v-if="this.form.currency !== '-1' && this.form.currency !== this.localCurrency"
                                    name="used_amount" summary-type="custom" show-in-column="used_amount"
                                />
                                <DxGroupItem
                                    :show-in-group-footer="true"
                                    name="local_amount"
                                    summary-type="custom"
                                    show-in-column="local_amount"
                                    display-format="{0}"
                                /> 
                                <DxTotalItem name="local_amount"
                                    summary-type="custom"
                                    show-in-column="local_amount"
                                />
                                <DxGroupItem
                                    :show-in-group-footer="true"
                                    name="used_local_amount"
                                    summary-type="custom"
                                    show-in-column="used_local_amount"
                                    display-format="{0}"
                                /> 
                                <DxTotalItem name="used_local_amount"
                                    summary-type="custom"
                                    show-in-column="used_local_amount"
                                />
                                <DxGroupItem
                                    :show-in-group-footer="true"
                                    name="remain_local_amount"
                                    summary-type="custom"
                                    show-in-column="remain_local_amount"
                                    display-format="{0}"
                                /> 
                                <DxTotalItem name="remain_local_amount"
                                    summary-type="custom"
                                    show-in-column="remain_local_amount"
                                />
                            </DxSummary>
                        </DxDataGrid> 
                    </div>
                </div> 
            </div>
        </div> 
    </div>  
     <!-- Collection and Payment Modal -->
     <div class="modal fade" id="kt_modal_view_collection_and_payment" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <OffsetDetailList  :list-type="0" :detailList="this.detailList"/>
    </div>
  </div>  
</template>
<script>
import axios from 'axios' 

import moment from 'moment';
import OffsetDetailList from './Modals/OffsetDetailList.vue';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
    name: "PaidList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem, DxScrolling,OffsetDetailList
    }, 
    data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            pageSize: 100,
            lists: [],  
            detailList: [],
            searchbar: '',
            form: {
                first_date:  moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),
                date_type: 2,
                currency: '-1',
                remain_status: 1
            },
            menuSelection: '/PaidHelppage',
            iconView : false,
            isListProgressing: false,
            dateTypeList: [
                { id: 1, text: this.$t('due_date')},
                { id: 2, text: this.$t('record_date')},
            ],
            isRemainStatusList: [
                { id: 1, text: this.$t('all')},
                { id: 2, text: this.$t('with_remain')},
                { id: 3, text: this.$t('no_remain')},
            ],
            currencyList: [],
            localCurrency: null
        };
    },
    computed: {
        searchableList() {
            return this.lists.filter(p => { 
                return p.account_name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
            });
        },
        previewDate(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
        showPageSizeSelectorLists() {
            return this.lists.length > this.pageSize;
        },
        pageSizesLists() {
            let arr = [];
            let x = 1;
            let loop = (this.lists.length / this.pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        },
        setColumnTemplateForLocal(){
            return (value)=>{
                const captionValue = value.column.caption.replace(this.$t('local'), ' ');
                return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);
            }
        },
    },
    methods: {
        getCurrencyList() {
            const parameters = {
                session_id: this.$getUser().session_id,
                list_name: ["currency"]
            };
            const requestOne =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'});
            axios.all([requestOne]).then(axios.spread((...responses) => {
                this.currencyList = responses[0].data.currency;
                this.currencyList.unshift({ id: '-1', text: this.$t('all')});
                this.localCurrency = this.$getUser().currency_code;
            }))
            .catch(errors => { 
                console.error(errors); 
            });
        },
        getData() {
            this.lists = [];
            this.isListProgressing = true;
            this.$Progress.start();
            this.form.first_date = (this.form.first_date == null || this.form.first_date == '') ? moment() : this.form.first_date;
            this.form.last_date = ( this.form.last_date == null || this.form.last_date == '') ? moment () : this.form.last_date;
            const queryParameter = {
                session_id: this.$getUser().session_id,
                first_date: moment(this.form.first_date).format('YYYY-MM-DD'),
                last_date: moment(this.form.last_date).format('YYYY-MM-DD'),
                bc_type: 4,
                date_type: this.form.date_type,
                currency: (this.form.currency !== '-1') ? this.form.currency : null,
                remain_status: this.form.remain_status
            };   
            const that = this;
            axios.post('/api/CollectionList/GetCollections', queryParameter, {'Content-Type': 'application/json'}) 
            .then((response) => {  
                this.lists = response.data;
                this.$Progress.finish();
            })
            .catch(() => {
                that.isListProgressing = false;
                this.$Progress.finish();
            })
            .finally(function() {
                that.isListProgressing = false;
                that.$Progress.finish();
            });
        },
        setCriteriasToDefault() {   
            this.form = {
                first_date:  moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),
                date_type: 2,
                currency: '-1',
                remain_status: 1
            };
            this.lists = [];
        },
        viewDetail(detailId){ 
            this.detailList = [];
            this.$Progress.start(); 
            const queryParameter = {
                session_id: this.$getUser().session_id,
                id: detailId,
                bc_type: 2
            };   
            axios.post('/api/CollectionList/GetDetails', queryParameter, {'Content-Type': 'application/json'}) 
                .then((response) => {  
                    this.detailList = response.data; 
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$Progress.finish();
                });
        },
        /** DX STATE OPERATIONS **/  
        LoadDXState() {
            return JSON.parse(sessionStorage.getItem(this.storageKey));
        }, 
        async helpPageViewIcon()
        {
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/PaidHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        }, 
        setSummaries(options){  
            const optionNames = ["amount", "remain_amount", "used_amount", "local_amount", "used_local_amount","remain_local_amount"]; 
            optionNames.forEach(item => {
                if(options.name == item){
                    if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                    else if(options.summaryProcess === 'calculate'){
                        var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                        (options.totalValue += itemValue);
                    }
                    else if(options.summaryProcess === 'finalize'){ 
                        options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                    }
                }
            });
        },
        onCustomizeColumn(e){
            if(e){
                if(!e._isUpdated){
                    if(e.length > 0){ 
                        e._isUpdated = true;
                    }
                    e.forEach((column) => {   
                        if(column.dataField == 'local_amount'){ 
                            column.caption = this.$t('local_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'used_local_amount'){ 
                            column.caption = this.$t('paid_local_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'remain_local_amount'){ 
                            column.caption = this.$t('remain_local_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'cross_amount_local'){ 
                            column.caption = this.$t('collection_local_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'cross_remain_amount_local'){ 
                            column.caption = this.$t('collection_local_remain');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                    });  
                } 
            } 
        },
        onRedirectBalanceClosing(data) {
            this.$swal.fire({
                title: this.$t('you_will_be_directed_to'),
                confirmButtonColor: "#50cd89",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'info'
            }).then((result) => {
                if (result.isConfirmed) { 
                    this.bcData = data;
                    this.bcData.item_type = 2;
                    this.bcData.transaction_number = data.transaction_no;
                    this.$router.push({ name: 'BalanceClosingOperations', params: { bcData: JSON.stringify(this.bcData) } });
                }
            });
        }
    },
    created() {
        this.getCurrencyList();
        this.helpPageViewIcon();
        this.lists = [];
        this.$removeSessionStorage('record_id');
    }
}; 
</script>